module.exports = __webpack_public_path__ + "img/912946870.2265bfeb.png";